/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LifestyleFactorHistory } from './LifestyleFactorHistory';
import {
    LifestyleFactorHistoryFromJSON,
    LifestyleFactorHistoryFromJSONTyped,
    LifestyleFactorHistoryToJSON,
} from './LifestyleFactorHistory';
import type { LifestyleFactorValue } from './LifestyleFactorValue';
import {
    LifestyleFactorValueFromJSON,
    LifestyleFactorValueFromJSONTyped,
    LifestyleFactorValueToJSON,
} from './LifestyleFactorValue';

/**
 * 
 * @export
 * @interface LifestyleFactor
 */
export interface LifestyleFactor {
    /**
     * 
     * @type {string}
     * @memberof LifestyleFactor
     */
    id?: string;
    /**
     * 
     * @type {LifestyleFactorValue}
     * @memberof LifestyleFactor
     */
    value?: LifestyleFactorValue;
    /**
     * 
     * @type {Array<LifestyleFactorHistory>}
     * @memberof LifestyleFactor
     */
    history?: Array<LifestyleFactorHistory>;
}

/**
 * Check if a given object implements the LifestyleFactor interface.
 */
export function instanceOfLifestyleFactor(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LifestyleFactorFromJSON(json: any): LifestyleFactor {
    return LifestyleFactorFromJSONTyped(json, false);
}

export function LifestyleFactorFromJSONTyped(json: any, ignoreDiscriminator: boolean): LifestyleFactor {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'value': !exists(json, 'value') ? undefined : LifestyleFactorValueFromJSON(json['value']),
        'history': !exists(json, 'history') ? undefined : ((json['history'] as Array<any>).map(LifestyleFactorHistoryFromJSON)),
    };
}

export function LifestyleFactorToJSON(value?: LifestyleFactor | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'value': LifestyleFactorValueToJSON(value.value),
        'history': value.history === undefined ? undefined : ((value.history as Array<any>).map(LifestyleFactorHistoryToJSON)),
    };
}

